import React from 'react';

export default function GoogleMapsSetupMessage({ extra }) {
  return (
    <div className="h-full min-h-[320px] bg-slate-50 dark:bg-slate-800 rounded-[40px] flex flex-col items-center justify-center p-8 text-center" role="status">
      <span className="material-symbols-outlined text-[64px] text-slate-300 mb-4">map_off</span>
      <h3 className="text-xl font-bold text-slate-500">Google Maps sozlanmagan</h3>
      <p className="text-sm text-slate-500 mt-2 max-w-md">
        <code className="bg-slate-100 dark:bg-slate-700 px-1 rounded">REACT_APP_GOOGLE_MAPS_API_KEY</code>
        {' '}ni <code className="bg-slate-100 px-1 rounded">.env</code> va Vercel Environment Variables ga qo&apos;shing.
      </p>
      <p className="text-xs text-slate-400 mt-4 max-w-sm">
        Google Cloud: Maps JavaScript API yoqing, billing ulang, key yarating (HTTP referrer: localhost va vercel.app).
      </p>
      {extra}
    </div>
  );
}
